import { memo } from "react";
import mapData from "@/content/mapDots.json";

export const MAP_W = mapData.cols * 10;
export const MAP_H = mapData.rows * 10;

// Converts latitude/longitude to SVG coordinates of the dotted map.
export const project = (lat, lon) => [((lon + 180) / mapData.step) * 10, ((mapData.latMax - lat) / mapData.step) * 10];

const regionOf = (idx) => mapData.regions[idx];

// Static dotted world map. `highlight` lists region ids drawn in the accent colour; `active` is emphasised.
export const DotField = memo(({ highlight = [], active = null }) => (
  <g>
    {mapData.dots.map(([c, r, reg], i) => {
      const id = regionOf(reg);
      const on = highlight.includes(id);
      const isActive = active === id;
      return (
        <circle
          key={i}
          cx={c * 10 + 5}
          cy={r * 10 + 5}
          r={on ? 3.4 : 2.6}
          className={`map-dot ${on ? "fill-accent" : "fill-ink"}`}
          opacity={on ? (active && !isActive ? 0.35 : isActive ? 1 : 0.75) : 0.16}
        />
      );
    })}
  </g>
));
DotField.displayName = "DotField";
